var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1.193","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M.49.99l12.02 12.02M12.51.99L.49 13.01"})));
}

CloseIcon.defaultProps = {"width":"13","height":"14"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
